import React from 'react';
import { Modal } from 'react-bootstrap';
import { ModalContext } from 'context/ModalContext';
import Add_Product_Benefit from '../forms/setup/Add_Product_Benefit';


function AddProductBenefit(props) {
    return (
   <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="text-grey">Add Benefit</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <NewUser/> */}
          <Add_Product_Benefit {...props} />
        </Modal.Body>
      </Modal>
    </div>
    );
}

export default AddProductBenefit;